import { render, staticRenderFns } from "./fastmail.vue?vue&type=template&id=438c184a&scoped=true&"
var script = {}
import style0 from "./fastmail.vue?vue&type=style&index=0&id=438c184a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438c184a",
  null
  
)

export default component.exports